var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return (_vm.isActive && _vm.isNotRouting) || _vm.hasError || _vm.onHome
    ? _c(
        "div",
        {
          ref: "sideContainer",
          class: { "side-container": true, closed: _vm.isContainerClosed },
          attrs: { id: "sideContainer" }
        },
        [
          _c(
            "button",
            {
              staticClass: "toggle-results-map",
              class: {
                close: _vm.isContainerClosed,
                hidden: _vm.hideMapToggle
              },
              on: {
                click: function($event) {
                  return _vm.toggleMap()
                }
              }
            },
            [
              !_vm.isContainerClosed
                ? _c("span", [_vm._v(_vm._s(_vm.i18n.resultsView.btnMapText))])
                : _vm._e(),
              _vm._v(" "),
              _vm.isContainerClosed
                ? _c("span", [
                    _vm._v(
                      _vm._s(
                        _vm.i18n.resultsView.amountOfResults(
                          _vm.entries.length,
                          true
                        )
                      )
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.entries.length
            ? _c(
                "div",
                {
                  staticClass: "results-container",
                  class: { closed: _vm.isContainerClosed }
                },
                [
                  _c(
                    "SimpleBar",
                    [
                      _c(
                        "div",
                        {
                          ref: "resultHeader",
                          staticClass: "result-list-header"
                        },
                        [
                          _c("p", { staticClass: "results-count" }, [
                            _vm._v(
                              _vm._s(
                                _vm.i18n.resultsView.amountOfResults(
                                  _vm.entries.length
                                )
                              )
                            )
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      _vm._l(_vm.entries, function(entry) {
                        return _c("result-item", {
                          key: `entry-${entry.idDecoded}`,
                          attrs: { entry: entry }
                        })
                      })
                    ],
                    2
                  )
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass: "results-container",
                  class: { "w-full": _vm.isHomePageAndApp }
                },
                [
                  _vm.onHome
                    ? _c("welcome-siede-view")
                    : _c(
                        "div",
                        {
                          ref: "resultHeader",
                          staticClass: "result-list-header"
                        },
                        [
                          _c("p", { staticClass: "results-count" }, [
                            _vm._v(
                              _vm._s(
                                _vm.i18n.resultsView.amountOfResults(
                                  _vm.entries.length
                                )
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm.hasError
                            ? _c("p", { staticClass: "error-notification" }, [
                                _vm._v(_vm._s(_vm.i18n.resultsView.serverError))
                              ])
                            : _vm._e()
                        ]
                      )
                ],
                1
              )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }